import removeMd from 'remove-markdown';
import xss from 'xss';

export const markdownToSanitizedText = (markdown: string): string => {
    return xss(
        removeMd(markdown, {
            stripListLeaders: false,
            useImgAltText: true,
        }).replace(/\s+/g, ' '),
    );
};
